export default __webpack_public_path__ + "static/media/24.c65d65be.png";